import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { CompaniesService } from '../../component/companies/service/companies.service';

@Component({
  selector: 'app-pull-back-farmout-modal',
  templateUrl: './pull-back-farmout-modal.component.html',
  styleUrls: ['./pull-back-farmout-modal.component.css']
})
export class PullBackFarmoutModalComponent implements OnInit, OnDestroy {
  @Input() tripData: any;
  @Output() pullBackTripData = new EventEmitter<any>();

  reason = '';
  componentLoad = false;

  constructor(private companiesService: CompaniesService) { }

  ngOnInit() {
  }

  confirmPullBack() {
    if (!this.reason || !this.reason.trim()) {
      return;
    }

    sweetAlert(
      'Alert',
      'Are you sure you want to pull back this trip?',
      'warning',
      'Yes',
      'No'
    ).then((result: any) => {
      if (result && result.value) {
        this.componentLoad = true;
        const payload = {
          tripId: this.tripData._id,
          status: 'canceled',
          cancelledTime: new Date().toISOString(),
          reason: this.reason
        };

        this.companiesService
          .cancelFarmoutRide(this.tripData._id, payload)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(data => {
            this.pullBackTripData.emit(data || true);
          }, err => {
            this.componentLoad = false;
            sweetAlert('Error', err, 'error', 'OK');
          });
      }
    });
  }

  closeModal() {
    this.pullBackTripData.emit();
  }

  ngOnDestroy(): void {
  }
}
